<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <fragment v-if="showEditForm">
      <EndorsementForm
        :form="form"
        @submit="submit"
        @approve="approveForm"
        name-button="SALVAR"
        :is-edit="canEditEndorsement"
        is-request-endorsement
        :can-approve-request="canApproveEndorsement"
        :can-reprove-request="canReproveEndorsement"
        @cancel="previousPage"
        @reprove="submitCancel"
      />
    </fragment>
    <fragment v-if="showApprovedForm">
      <EndorsementForm
        :form="form"
        @submit="submitNewEndorsement"
        name-button="CRIAR"
        @cancel="previousPage"
        is-create
      />
    </fragment>
    <ModalGenericCriticism
      v-if="modal"
      v-model="modal"
      @close="previousPage"
      :title="titleModal"
      :text="textModal"
    />
    <ModalCancelEndoserment
      @close="closeModalCancel"
      v-model="modalCancelEndoserment"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import EndorsementForm from "../components/EndorsementForm";
import { mapActions } from "vuex";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelEndoserment from "../../insurance_company/components/ModalCancelInsurance";
import RequestEndorsementMixin from "@/mixins/RequestEndorsementMixin";
export default {
  data: () => ({
    form: null,
    formatDateToDDMMYYYY,
    modal: false,
    cloneForm: {},
    editRequestEndorsement: true,
    editForm: true,
    titleModal: "ENDOSSO CRIADO",
    textModal: "Novo endosso foi criado com sucesso."
  }),
  components: {
    EndorsementForm,
    ModalGenericCriticism,
    ModalCancelEndoserment
  },
  mixins: [RequestEndorsementMixin],
  mounted() {
    this.withLoading(
      this.requestCurrentRequestEndorsement(this.getIdsPayload())
    );
  },
  computed: {
    canEditEndorsement() {
      return this.currentRequestEndorsement.acoes?.pode_editar;
    },
    canApproveEndorsement() {
      return this.currentRequestEndorsement.acoes?.pode_aprovar;
    },
    canReproveEndorsement() {
      return this.currentRequestEndorsement.acoes?.pode_reprovar;
    },
    showEditForm() {
      return !this.emptyCurrentPolicy && this.form && this.editForm;
    },
    showApprovedForm() {
      return !this.editForm;
    },
    breadcrumb() {
      return [
        {
          text: this.canEditEndorsement
            ? "Editar Solicitação Endosso"
            : "Visualizar Solicitação Endosso",
          to: "policy"
        }
      ];
    }
  },
  methods: {
    ...mapActions("policy", [
      "requestCurrentRequestEndorsement",
      "requestEditRequestEndorsement",
      "requestCancelRequestEndorsement"
    ]),
    async submit(form) {
      this.withLoading(
        this.requestEditRequestEndorsement(
          await this.payloadEditEndorsement(form)
        ).then(() => {
          this.titleModal = "SOLICITAÇÃO DE ENDOSSO EDITADA";
          this.textModal = "A solicitação de endosso foi editada com sucesso.";
          this.modal = true;
          this.cancel = true;
        })
      );
    },
    submitCancel() {
      this.withLoading(
        this.requestCancelRequestEndorsement(this.$route.params).then(() => {
          this.titleModal = "SOLICITAÇÃO DE ENDOSSO REPROVADA";
          this.textModal =
            "A solicitação de endosso foi reprovada com sucesso.";
          this.modal = true;
          this.cancel = true;
        })
      );
    },
    approveForm() {
      this.breadcrumb = [
        {
          text: "Novo Endosso",
          to: "policy"
        }
      ];
      this.form.numero = null;
      this.editForm = false;
    },
    async payloadEditEndorsement(form) {
      return {
        id: this.$route.params.id,
        payload: await this.getPayloadRequestEndorsement(form),
        endosso: this.$route.params.endosso
      };
    },
    getIdsPayload() {
      return {
        id: this.$route.params.id,
        endosso: this.$route.params.endosso
      };
    }
  }
};
</script>
